import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ProductService } from 'src/app/services/product.service';
import { Product } from 'src/app/models/product';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/reducers/app-store';
import { Category } from 'src/app/models/category';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-create-product',
  templateUrl: './create-product.component.html',
  styleUrls: ['./create-product.component.scss'],
  providers: [
    { provide: STEPPER_GLOBAL_OPTIONS, useValue: { showError: true } }
  ]
})
export class CreateProductComponent implements OnInit {

  // Data
  products: Product[];
  categories: Category[];
  subCategories: string[];
  productsTypes: string[];

  // Forms
  productForm: FormGroup = this.fb.group({
    nameProductForm: [null, Validators.required],
    categoryForm: [null, Validators.required],
    subCategoriesForm: [{ value: null, disabled: true }, Validators.required],
    // productTypeForm: [null, Validators.required],
    // attributeForm: [null],
    // attributesForm: [{ value: null, disabled: true }]
  });
  descriptionForm: FormGroup = this.fb.group({
    title: [null, Validators.required],
    subTitle: [null],
    description: [null, [Validators.required, Validators.maxLength(256)]]
  });
  informationForm: FormGroup = this.fb.group({
    brand: [null, Validators.required],
    model: [null],
    line: [null]
  });
  colorsForm: FormGroup = this.fb.group({
    colors: [null, [Validators.required]]
  });

  // FormControlers
  colorTypeCtrl = new FormControl('hex', Validators.required);
  hexCodeCtrl = new FormControl(null, Validators.required);
  colorDescCtrl = new FormControl(null, Validators.required);

  // Lists
  colorsSelected: any[] = [];
  colorsChips: any[] = [];
  showOptionsTextiles = false;

  // Vars
  fileDescription: File = null;
  fileColor: { file: File, fileUrl: string };
  errorDescription = '';
  errorColor = false;
  showColorDrop = false;

  // Observables
  dataImage = new BehaviorSubject<DataImage>(null);
  dataImage$ = this.dataImage.asObservable();

  // mat-chips
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  attibutteValues: string[] = [];

  constructor(
    private productService: ProductService,
    private fb: FormBuilder,
    private store: Store<{ appState: AppState }>) { }

  ngOnInit() {
    // cargamos las sub-categorias de la categorias seleccionada
    this.productForm.controls.categoryForm.valueChanges.subscribe((category: Category) => {
      this.productForm.controls.subCategoriesForm.enable();
      this.subCategories = category.subCategories;
    });
    // Caundo cambiemos de tipo de color cambiamos el select
    this.colorTypeCtrl.valueChanges.subscribe((type: string) => {
      this.showColorDrop = type === 'img' ? true : false;
    });
    // Cuando se cargue una imagen  validamos y mantenemos para guardar
    this.dataImage$.subscribe((data: DataImage) => {
      if (data) {
        switch (data.idDrop) {
          case 'descriptionDrop':
            this.fileDescription = data.file;
            break;
          case 'colorDrop':
            if (data.height > 48
              || data.width > 48
              || data.height < 40
              || data.width < 40) {
              this.errorColor = true;
              console.log('erro', data);
            } else {
              this.fileColor = { file: data.file, fileUrl: data.fileUrl };
              console.log('todo bien', data);
            }
            break;

          default:
            break;
        }
      }
    });
    // this.productForm.controls.productTypeForm.valueChanges.subscribe(productType => {
    //   if (productType === 'Textile') {
    //     this.showOptionsTextiles = true;
    //   } else {
    //     this.showOptionsTextiles = false;
    //   }
    // });
    // Sleccionamos las categorias y tipos de productos del reducer
    this.store.select(state => state.appState.categories).subscribe(items => this.categories = items);
    this.store.select(state => state.appState.productType).subscribe(items => this.productsTypes = items);
  }


  addChips(event: MatChipInputEvent, idComponent: string, params?: any): void {
    // Si estamos agregando en el chip de colors
    if (idComponent === 'colorChip') {
      // Validaciones
      if (this.colorTypeCtrl.value === 'hex' && this.hexCodeCtrl.invalid) {
        console.log('hex', this.hexCodeCtrl.invalid);
        return;
      }
      if (this.colorTypeCtrl.value === 'img' && !this.fileColor) {
        this.errorColor = true;
        this.colorDescCtrl.markAsTouched();
        return;
      }
      if (this.colorDescCtrl.invalid) {
        this.colorDescCtrl.markAsTouched();
        return;
      }
      // Cargamos lista que va a persistir Necesario para las tallas
      this.colorsSelected.push({
        color: this.fileColor ? this.fileColor : this.hexCodeCtrl.value.hex,
        name: this.colorDescCtrl.value.trim(),
        sizes: []
      });
      // Cargamos en el formulario para validar vista
      this.colorsForm.controls.colors.patchValue(this.colorsSelected);
      // Cargamos lista para mostrar en el mat-chip de colores
      const colorObject: any = {};
      colorObject.sizes = [];
      colorObject.name = this.colorDescCtrl.value;
      if (this.fileColor) {
        colorObject.background = { 'background-image': 'url(\'' + this.fileColor.fileUrl + '\')' };
      } else {
        colorObject.background = { 'background-color': '#' + this.hexCodeCtrl.value.hex };
      }
      this.colorsChips.push(colorObject);
      // Reiniciamos Controlers y el drop de imagenes
      this.fileColor = null;
      this.hexCodeCtrl.reset();
      this.colorDescCtrl.reset();
      if (this.showColorDrop) {
        document.getElementById('colorDrop').style.backgroundImage = '';
        document.getElementById('colorDrop').style.backgroundPosition = '';
        document.getElementById('colorDrop').style.backgroundRepeat = '';
        document.getElementById('colorDrop').style.backgroundSize = '';
      }
      return;
    }

    // Si estamos en el chip de tallas
    if (idComponent === 'sizeChip') {
      const input = event.input;
      const value = event.value;
      if ((value || '').trim()) {
        this.colorsSelected.map(color => {
          if (color.name === params.name) {
            color.sizes.push(value.trim());
          }
          return color;
        });
        this.colorsChips.map(color => {
          if (color.name === params.name) {
            color.sizes.push(value.trim());
          }
          return color;
        });
      }
      if (input) {
        input.value = '';
      }
    }
  }

  removeChip(item: any, idComponent: string): void {
    if (idComponent === 'colorChip') {
      this.colorsChips = this.colorsChips.filter(color => color.name !== item.name);
      this.colorsSelected = this.colorsSelected.filter(color => color.name !== item.name);
      this.colorsForm.controls.colors.setValue(this.colorsSelected.length === 0 ? null : this.colorsSelected);
    }
  }

  async handleFileInput(files: FileList, id: string) {
    this.errorColor = false;
    if (files.length > 0) {
      let dataImage: DataImage;
      // Cambiamos el background del div por la imagen seleccionada
      const reader = new FileReader();
      let width: number;
      let height: number;
      reader.onload = (e: any) => {
        document.getElementById(id).style.backgroundImage = `url(${reader.result})`;
        document.getElementById(id).style.backgroundPosition = 'center';
        document.getElementById(id).style.backgroundRepeat = 'no-repeat';
        document.getElementById(id).style.backgroundSize = 'cover';
        // Obtenemos las dimensiones de la imagen para validar
        const image = new Image();
        image.src = e.target.result;
        image.onload = rs => {
          height = rs.currentTarget['height'];
          width = rs.currentTarget['width'];
          dataImage = {
            file: files.item(0),
            fileUrl: `${reader.result}`,
            height,
            width,
            idDrop: id
          };
          // Emitimos en el observable
          this.dataImage.next(dataImage);
        };
      };
      reader.readAsDataURL(files[0]);
    }
  }
}

export interface DataImage {
  idDrop: string;
  width: number;
  height: number;
  file: File;
  fileUrl: string;
}
